import type { Supplier } from '../../../types'
import { bandCountsUnique, collapseSuppliersByName } from '../supplierRollup'

export type BriefPortfolio = 'direct' | 'indirect'

export type BriefCatalogItem = {
  category: string
  portfolio: BriefPortfolio
  supplierCount: number
  high: number
}

export function portfolioOfSupplier(s: Supplier): BriefPortfolio {
  return s.procurement_type === 'indirect' ? 'indirect' : 'direct'
}

export function briefKey(item: { category: string; portfolio: BriefPortfolio }): string {
  return `${item.portfolio}::${item.category}`
}

/** One brief per category that has suppliers, in the portfolio those suppliers sit in. */
export function buildBriefCatalog(roster: Supplier[]): BriefCatalogItem[] {
  const groups = new Map<string, Supplier[]>()
  for (const s of roster) {
    const category = (s.category || '').trim()
    if (!category) continue
    const portfolio = portfolioOfSupplier(s)
    const key = briefKey({ category, portfolio })
    const list = groups.get(key) || []
    list.push(s)
    groups.set(key, list)
  }

  const items: BriefCatalogItem[] = []
  for (const rows of groups.values()) {
    const category = (rows[0].category || '').trim()
    const portfolio = portfolioOfSupplier(rows[0])
    const bands = bandCountsUnique(collapseSuppliersByName(rows))
    items.push({
      category,
      portfolio,
      supplierCount: bands.total,
      high: bands.high,
    })
  }
  items.sort(
    (a, b) => b.supplierCount - a.supplierCount || a.category.localeCompare(b.category)
  )
  return items
}

export function suppliersForBrief(
  roster: Supplier[],
  category: string,
  portfolio: BriefPortfolio
): Supplier[] {
  return roster.filter(
    (s) => (s.category || '').trim() === category && portfolioOfSupplier(s) === portfolio
  )
}
